import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
// import p1 from 'assests/Photos/Clubs/LitreryClub/2023/Storytelling/1.jpg';
// import p2 from 'assests/Photos/Clubs/LitreryClub/2023/Storytelling/2.jpg';
// import p3 from 'assests/Photos/Clubs/LitreryClub/2023/Storytelling/3.jpg';
// import p4 from 'assests/Photos/Clubs/LitreryClub/2023/Storytelling/4.jpg';
// import p5 from 'assests/Photos/Clubs/LitreryClub/2023/Storytelling/5.jpg';
// import p6 from 'assests/Photos/Clubs/LitreryClub/2023/Storytelling/6.jpg';
// import p7 from 'assests/Photos/Clubs/LitreryClub/2023/Storytelling/7.jpg';
// import p8 from 'assests/Photos/Clubs/LitreryClub/2023/Storytelling/8.jpg';
// import p9 from 'assests/Photos/Clubs/LitreryClub/2023/Storytelling/9.jpg';
// import p10 from 'assests/Photos/Clubs/LitreryClub/2023/Storytelling/10.jpg';
// import p11 from 'assests/Photos/Clubs/LitreryClub/2023/Storytelling/11.jpg';
// import p12 from 'assests/Photos/Clubs/LitreryClub/2023/Storytelling/12.jpg';
// import p13 from 'assests/Photos/Clubs/LitreryClub/2023/Storytelling/13.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/Literaryclub2023/components';
import { LiterarySidebar } from 'views/Literaryclub2023/components';

const StoryTelling2023 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [config, setConfig] = useState({ base_image_archive_url: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/association/LitreryClub/Storytelling/1.webp`;
    const p2 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/association/LitreryClub/Storytelling/2.webp`;
    const p3 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/association/LitreryClub/Storytelling/3.webp`;
    const p4 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/association/LitreryClub/Storytelling/4.webp`;
    const p5 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/association/LitreryClub/Storytelling/5.webp`;
    const p6 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/association/LitreryClub/Storytelling/6.webp`;
    const p7 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/association/LitreryClub/Storytelling/7.webp`;
    const p8 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/association/LitreryClub/Storytelling/8.webp`;
    const p9 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/association/LitreryClub/Storytelling/9.webp`;
    const p10 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/association/LitreryClub/Storytelling/10.webp`;
    const p11 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/association/LitreryClub/Storytelling/11.webp`;
    const p12 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/association/LitreryClub/Storytelling/12.webp`;
    const p13 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/association/LitreryClub/Storytelling/13.webp`;

    const photos = [
               {
                    src: p3,
                    source: p3,
                    rows: 1.3,
                    cols: 2,
                },  
          {
                    src: p1,
                    source: p1,
                    rows: 1,
                    cols: 2,
          },
          {
                    src: p2,
                    source: p2,
                    rows: 1,
                    cols: 1,
          },
          {
                    src: p4,
                    source: p4,
                    rows: 1,
                    cols: 1,
                },
                {
                    src: p5,
                    source: p5,
                    rows: 1,
                    cols: 2,
                },  
          {
                    src: p6,
                    source: p6,
                    rows: 1.4,
                    cols: 2,
          },
          {
                    src: p7,
                    source: p7,
                    rows: 1.2,
                    cols: 2,
          },
          {
                    src: p8,
                    source: p8,
                    rows: 1,
                    cols: 2,
                },
                {
                    src: p9,
                    source: p9,
                    rows: 1,
                    cols: 2,
                },
                {
                    src: p10,
                    source: p10,
                    rows: 1,
                    cols: 2,
                },
                {
                    src: p11,
                    source: p11,
                    rows: 1,
                    cols: 1,
                },
                {
                    src: p12,
                    source: p12,
                    rows: 1,
                    cols: 1,
                },
                {
                    src: p13,
                    source: p13,
                    rows: 1,
                    cols: 2,
                },
    ];

    return (
        <Main>

            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box paddingX={{ xs: 0, sm: 4, md: 6 }}>
                            <Typography variant='h5' align='center' >
                            STORY TELLING    
                                </Typography>
                              
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Class: Pre-Primary         Date: 09 FEBRUARY 2024
                                </Typography>
                                <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                              ><br />
                                "In our Pre-Primary classrooms, storytelling is not just a fun activity; it is a creative journey where young minds explore the wonders of imagination."
                                <br />
                               </Typography>
                               <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                The Pre-Primary department at National Public School Yeshwanthpur conducted a Story Telling activity for the students of Montessori and Kindergarten on Friday, 09 February 2024 as part of communication and vocabulary enrichment exercises. Our vibrant students delved into the enchanting world of storytelling with their stupendous narratives and transported us to realms filled with Eric Carle's whimsical creatures, hilarious and unique funny stories, and the rhythmic charm of cherished rhymes.
                                <br />
                                <strong>Eric Carle Stories:</strong>
                                <br />
                                The students of Montessori-III and KG-II presented Eric Carle's timeless tales that captivated our students' imagination, inspiring them to create their own versions of his beloved stories. From "The Very Hungry Caterpillar" to "Brown Bear, Brown Bear, What Do You See?" each narrative was a testament to the power of colourful illustrations and captivating storytelling. Our students' reimagined adventures with these characters and showcased their creativity and appreciation for Carle's iconic style through their book reading sessions.
                                <br />
                               <strong>Unique Funny Stories:</strong> 
                                <br />
                                Laughter filled the air as our Montessori-II, KG-I and Pre-Nurture students shared their unique and hilarious stories. From mischievous animals embarking on unexpected adventures to imaginative mishaps in everyday life, each tale was a testament to the boundless creativity of young minds. Through their narratives, our students demonstrated their ability to find humour in the ordinary and weave it into extraordinary stories that left us all smiling.
                                <br />
                                <strong>Rhymes:</strong> 
                                <br />
                                The rhythmic cadence of rhymes echoed through our classroom as our Montessori-I and Pre-K students shared their favourite verses and crafted their own melodic tales. From classic nursery rhymes to regional compositions, each rhyme was a celebration of language and rhythm. Through their presentation, our students showcased their mastery of phonetics and the joy of playful expression, captivating listeners with their infectious enthusiasm.
                                <br />
                                In the world of Pre-Primary storytelling and imagination knows no bounds. Through their exploration of Eric Carle stories, Unique Funny Narratives, and Rhythmic Rhymes, our students have proven themselves to be budding storytellers with boundless creativity. We extend our heartfelt gratitude to the parents and most importantly, the students who made this storytelling activity a memorable and enriching experience. As they continue on their storytelling journey, we eagerly anticipate the tales they are yet to weave and the adventures that await within the pages of their imaginations. 

                                <div 
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                                className="Segoe UI">
      <p style={{ fontFamily: 'Segoe UI' }}> <strong>Tiny voices, Mighty imaginations!</strong></p>
    </div>

                                </Typography>
                                <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                              ><br />
                                "Sparkling Smiles and Boundless surprise!"
                                <br />
                            </Typography>
                            </Box>
                            
                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 500}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>

                        <Box marginBottom={4}>
                                    <Sidebar2023/>
                        </Box>
                        <Box marginBottom={4}>
                            <LiterarySidebar/>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Main>


    );
};

export default StoryTelling2023;